export const Farcaster = () => {
  return (
    <svg width="520" height="457" viewBox="0 0 520 457">
      <path
        d="M519.801 0V61.681H458.172V123.31H477.054V123.331H519.801V456.795H416.57L416.507 456.49L363.832 207.03C358.81 183.251 345.667 161.736 326.827 146.434C307.988 131.133 284.255 122.71 260.006 122.71H259.8C235.551 122.71 211.818 131.133 192.979 146.434C174.139 161.736 160.996 183.259 155.974 207.03L103.239 456.795H0V123.323H42.747V123.31H61.626V61.681H0V0H519.801Z"
        fill="currentColor"
      />
    </svg>
  )
}
